import { IsBoolean } from "class-validator";

export class AdminResetUserPasswordResult {
    @IsBoolean()
    success: boolean;
}